import React from "react";

// MUI Comp:
import { IconButton } from "@mui/material";

// Styled comp:
import { styled } from '@mui/material/styles';

// React Icons:
import FavoriteIcon from '@mui/icons-material/Favorite';

// context
import { useFavorites, useFavoritesDispatch } from "../../../Context/FavoritesContext";

// Theme
import { useTheme } from '@mui/material/styles';


    const FavIconCntnr =  styled(IconButton) ({
        width:'50px',
        textAlign:'center',
        position:'absolute',
        left:'3%',
        zIndex:1,
        height:'50px',
        top:'3%',
    });

function FavoriteButton({currObjID}) {

      const favoritesList   =  useFavorites(),
            favListDispatch =  useFavoritesDispatch(),
            theme           = useTheme();


  const onFavoriteClick = (oEvent) => {

      oEvent.preventDefault();

      if(!favoritesList) {return};

      let bItemExist = favoritesList.find(oItem => oItem.objID === currObjID );

      if (!bItemExist) { favListDispatch({ type: 'add', objID:  currObjID }); }

      if(bItemExist)  {  favListDispatch ({ type: 'delete', objID:  currObjID  }); }
  }



    return(
        <FavIconCntnr>
            <FavoriteIcon
                sx={{ color : favoritesList && favoritesList.length > 0 ?  favoritesList.find( (item) => item.objID === currObjID) && favoritesList.find( (item) => item.objID === currObjID).isFavorite ===  true  ? theme.palette.ochre.favorite : 'gray' : 'gray' }}
                data-value={currObjID} 
                onClick={onFavoriteClick}/>
        </FavIconCntnr>
    );
}

export default FavoriteButton;